export enum PayPalFormInputNames {
  EmailAddress = 'payPalValue',
}
